import React, { useEffect, useState } from "react";
import { Alert, Row, Col, Form, Label, UncontrolledTooltip } from "reactstrap";

import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// hooks
import { useProfile, useRedux } from "../../hooks/index";
import { createSelector } from "reselect";
//actions
import { loginUser, socialLogin } from "../../redux/actions";

// services
import { loginUserAccount } from "../../services/auth";
import { generateJWT } from "../../api/auth";

// utils
import { redirectAfterDelay } from "../../utils/redirectAfterDelay";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useTranslation } from "react-i18next";

import logo from "../../assets/images/logo.webp";
import letterLogo from "../../assets/images/letter-logo.webp";
import topLogo from "../../assets/images/top-logo.webp";
import loginImg from "../../assets/images/loginImg.webp";
import manOnLoginImg from "../../assets/images/manOnLoginImg.webp";
import checkboxImg from "../../assets/images/checkboxImg.webp";
import clientImg from "../../assets/images/client.webp";
import surveyImg from "../../assets/images/survey.webp";
import invoiceIcon from "../../assets/images/invoiceIcon.webp";
import feedbackIcon from "../../assets/images/feedbackIcon.webp";
import donateIcon from "../../assets/images/donateIcon.webp";
import topBg from "../../assets/images/top-bg.webp";
import smallTopBg from "../../assets/images/small-top-bg.webp";
import CookieBanner from "../../components/CookieBanner";
import LanguageSwitcher from "../../components/LanguageSelector";

const auth = getAuth();

const LandingPage = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };
  const handleClickTryout = () => {
    navigate("/auth-register");
  };
  const handleClickLearnMore = () => {
    navigate("/learn-more");
  };

  return (
    <div className="bg">
      <Navbar expand="lg" className="px-3 pt-3">
        <Container fluid>
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>
          <span className="d-flex gap-3">
            <span className="d-block d-lg-none">
              <LanguageSwitcher />
            </span>
            <Navbar.Toggle
              aria-controls="offcanvasNavbar-expand"
              style={{ fontSize: "1rem", padding: "5px 7px" }}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar-expand"
              aria-labelledby="offcanvasNavbarLabel-expand"
              placement="end" // Right side
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                  {t("Menu")}
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {/* Center-Right: Menu Items */}
                <Nav className="ms-auto me-3">
                  <Button
                    className="rounded-pill py-1 d-none d-lg-block"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                        "_blank",
                      )
                    }
                  >
                    {t("Donate")}
                  </Button>
                  <Nav.Link
                    as={Link}
                    to="/about-us"
                    className="top-menu-text-color"
                  >
                    {t("ABOUT US")}
                  </Nav.Link>
                  <Nav.Link
                    as={Link}
                    to="/learn-more"
                    className="top-menu-text-color"
                  >
                    {t("LEARN MORE")}
                  </Nav.Link>
                </Nav>

                {/* Right: Button */}

                <Button
                  className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                  style={{
                    backgroundColor: "#ede7e7",
                    color: "gray",
                    borderColor: "#ede7e7",
                    paddingRight: "40px",
                    paddingLeft: "40px",
                  }}
                  onClick={() =>
                    window.open(
                      "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                      "_blank",
                    )
                  }
                >
                  {t("Donate")}
                </Button>
                <Button
                  className="rounded-pill px-3 py-1 d-none d-lg-block"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>

                {/* <LanguageSwitcher /> */}
                <Button
                  className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                  style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/auth-register");
                  }}
                >
                  {t("Try out for free")}
                </Button>
                <span className="d-none d-lg-block">
                  <LanguageSwitcher />
                </span>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </span>
        </Container>
      </Navbar>

      <div className="section wrapper1">
        <div className="w-half">
          <div className="main-title">{t("The fair")}</div>
          <div className="main-title"> {t("invoice solution")}</div>
          <div className="image-container">
            <div className="text-overlay manImg-top">
              <p style={{ fontWeight: "600" }}>
                {t(
                  "Hero-Invoice is a smart, simple, and fair e-invoicing platform designed specifically for freelancers, self-employed professionals and small businesses.",
                )}
              </p>
              <p style={{ fontWeight: "600" }}>
                {t(
                  "Without bloated features or expensive subscription models.",
                )}
              </p>
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "30px" }}
              >
                <Button
                  className="rounded-pill px-3 py-1"
                  style={{ backgroundColor: "#23638e", borderColor: "white" }}
                  onClick={handleClickTryout}
                >
                  {t("Try out for free")}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-half">
          <img src={smallTopBg} className="top-bg img-responsive" />
        </div>
      </div>
      <div className=" mt-4 mt-md-0" id="section2">
        <div className="d-flex wrapper2 align-items-center">
          <div className="w-60">
            <img src={loginImg} className="img-responsive" />
          </div>
          <div className="section2-text-container">
            <p className="sub-title">{t("SIMPLE. FAIR. DONE.")}</p>
            <h2 style={{ fontWeight: "800" }}>{t("No Abo - Just pay")}</h2>
            <h2 style={{ fontWeight: "800" }}>{t("what you need")}</h2>
            <ul
              style={{ listStyle: "none", paddingLeft: "0", marginTop: "20px" }}
            >
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                <span>
                  <p className="fw-bold">{t("Free for small businesses:")}</p>
                  <p>
                    {t(
                      "If you only issue 2 to 3 invoices per month, our service is completely free for you.",
                    )}
                  </p>
                </span>
              </li>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                <span>
                  <p className="fw-bold">
                    {t(
                      "From the 4th invoice onwards: Only 10 cents per invoice:",
                    )}
                  </p>
                  <p>
                    {t(
                      "Only from the fourth invoice onwards, a minimal fee of just €0.10 per invoice is charged – fair and transparent.",
                    )}
                  </p>
                </span>
              </li>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                <span>
                  <p className="fw-bold">
                    {t("Frequent writer? It remains affordable:")}
                  </p>
                  <p>
                    {t(
                      "If you regularly issue more invoices, you can switch to a suitable plan at any time – so you always benefit from favorable terms.",
                    )}
                  </p>
                </span>
              </li>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                <span>
                  <p className="fw-bold">
                    {t("No subscription – full flexibility:")}
                  </p>
                  <p>
                    {t(
                      "Instead of a subscription, you simply purchase credit as needed, thus retaining full control at all times.",
                    )}
                  </p>
                </span>
              </li>
            </ul>
            <div className="d-flex justify-content-center">
              <Button
                className="rounded-pill px-3 py-1"
                style={{ backgroundColor: "#23638e", borderColor: "white" }}
                onClick={handleClickLearnMore}
              >
                {t("LEARN MORE")}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="section" id="section3">
        <div
          className="d-flex wrapper1"
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <div className="w-40 section3-content">
            <p className="sub-title">{t("INVOICING WITHOUT THE DRAMA")}</p>
            <h2 style={{ fontWeight: "800" }}>{t("All you need.")}</h2>
            <h2 style={{ fontWeight: "800" }}>{t("Nothing you don't.")}</h2>
            <ul
              style={{ listStyle: "none", paddingLeft: "0", marginTop: "20px" }}
            >
              <p style={{ color: "gray", fontWeight: "600", fontSize: "18px" }}>
                {t(
                  "Hero-Invoice is a super easy-to-use invoicing tool that gives you everything you actually need - without any of the fluff.",
                )}
              </p>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                {t("No bloated features")}
              </li>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                {t("No confusing workflows")}
              </li>
              <li className="checkbox-text">
                <img
                  src={checkboxImg}
                  style={{ width: "20px", height: "20px" }}
                />
                {t("No hidden limitations")}
              </li>
            </ul>
            <p style={{ color: "gray", fontWeight: "600", fontSize: "18px" }}>
              {t(
                "Instead: Simply create invoices. Fast, clear, efficient – ​​exactly the way you need them.",
              )}
            </p>
          </div>
          <div className="w-half section3-image">
            <img src={clientImg} className="img-responsive" />
          </div>
        </div>
      </div>
      <div className="section" id="section4">
        <div className="d-flex align-items-center wrapper2">
          <div className="w-60">
            <img src={surveyImg} className="img-responsive" />
          </div>
          <div className="w-40 mt-4 px-2 mx-4">
            <p className="sub-title">
              {t("TRY HERO-INVOICE BETA - NO COST, NO HASSLE")}
            </p>
            <h2 style={{ fontWeight: "800" }}>{t("Try it now -")}</h2>
            <h2 style={{ fontWeight: "800" }}>
              {t("and help shape the future.")}
            </h2>
            <div style={{ color: "gray", fontWeight: "600", fontSize: "18px" }}>
              <p>
                {t(
                  "Hero-Invoice is in open beta – and you're cordially invited to join us fro the very beginning!",
                )}
              </p>
              <ul>
                <li>{t("Use all features for free")}</li>
                <li>{t("Experience how easy invoicing can be")}</li>
                <li>
                  {t("Provide feedback and actively influence development")}
                </li>
              </ul>
              <p>
                {t(
                  "Your opinion counts: Together with you, we want to create the invoicing tool you've always wanted – clear, efficient, and to the point.",
                )}
              </p>
              <p>{t("Try it now and help shape it!")}</p>
              <div
                className="d-flex justify-content-center"
                style={{ marginTop: "30px" }}
              >
                <Button
                  className="rounded-pill px-3 py-1"
                  style={{ backgroundColor: "#23638e", borderColor: "white" }}
                  onClick={handleClickLearnMore}
                >
                  {t("LEARN MORE")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section" id="section5">
        <div className="right-rounded-bg">
          <div className="section5-main-title">
            {t("You're the Hero - We're Just the Tools")}
          </div>
          <div className="section5-subtitle">
            {t(
              "Hero-Invoice is made for real people who just want to get things done-without distractions, paywalls, or headaches. We're building this with you, not just for you. Want to support us or get involved ?",
            )}
          </div>
          <div className="section5-container">
            <div className="box">
              <div className="top-center-icon">
                <img src={invoiceIcon} width="60" height="70" />
              </div>
              <div className="bottom-center-icon">
                <Button
                  className="rounded-pill px-3 py-1"
                  style={{ backgroundColor: "#23638e", borderColor: "white" }}
                  onClick={handleClickTryout}
                >
                  {t("Sign up for free")}
                </Button>
              </div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Start Invoicing for Free")}
                </h4>
                <p
                  style={{ color: "gray", fontWeight: "600" }}
                  className="box-letter"
                >
                  {t(
                    "Experience the simplicity yourself no sign-up cost, no strings attached.",
                  )}
                </p>
              </div>
            </div>
            <div className="box">
              <div className="top-center-icon">
                <img src={feedbackIcon} width="60" height="70" />
              </div>
              <div className="bottom-center-icon">
                <Button
                  className="rounded-pill px-3 py-1"
                  style={{ backgroundColor: "#23638e", borderColor: "white" }}
                  onClick={() => {
                    navigate("/contact-us");
                  }}
                >
                  {t("Contact us")}
                </Button>
              </div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Leave Your Feedback")}
                </h4>
                <p
                  style={{ color: "gray", fontWeight: "600" }}
                  className="box-letter"
                >
                  {t(
                    "Tell us what works, what doesn't, or what you'd love to see next.",
                  )}
                </p>
              </div>
            </div>
            <div className="box">
              <div className="top-center-icon">
                <img src={donateIcon} width="60" height="70" />
              </div>
              <div className="bottom-center-icon">
                <Button
                  className="rounded-pill px-3 py-1"
                  style={{ backgroundColor: "#23638e", borderColor: "white" }}
                  onClick={() =>
                    window.open(
                      "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                      "_blank",
                    )
                  }
                >
                  {t("Donate")}
                </Button>
              </div>
              <div className="section5-letter-box d-flex flex-column justify-content-between h-75">
                <h4 style={{ fontWeight: "700" }}>
                  {t("Support Our Mission")}
                </h4>
                <p
                  style={{ color: "gray", fontWeight: "600" }}
                  className="box-letter"
                >
                  {t(
                    "If you believe in tools made for people (not profit), help us keep Hero-Invoice fair and independent. Every contribution counts.",
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default LandingPage;
